const poll = (f, timer = 100, continuous = false, timeout = null) => {
	let intervalId = null;
	let timeTaken = 0;
	intervalId = setInterval(() => {
		if ((f() && !continuous) || (timeout && timeTaken >= timeout)) {
			clearInterval(intervalId);
		}
		timeTaken += timer;
	}, timer);
	return intervalId;
};

module.exports = poll;
